import { SET_SETTINGS } from "../actions/type";

const initialState = {
  settings: {
    distanceUnit: "km",
    language: "en",
    showScale: false,
    noImage: false,
    rotationMode: false,
    sortNeighboursAlphabetically: false,
  },
  stats: {
    played: 3,
    winRate: 33,
    currentStreak: 6,
    maxStreak: 1,
    bestDistancesAverage: 2315,
    guessDistributions: [0, 0, 0, 1, 0],
  },
};

const gameReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SETTINGS:
      return {
        ...state,
        settings: action.payload,
      };
    default:
      return state;
  }
};

export default gameReducer;
